/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ImmutableState, SuggestedTopicState } from './SuggestedTopicState.types.tsx';

export const getSuggestedTopics = (state: ImmutableState): SuggestedTopicState => state.topics;

export const getPageNumber = (state: ImmutableState): number => state.page;
